<template>
  <div class="encyclopedias " style="min-height:50vw">
    <div class="container clearf">
      <div class="left-box">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{path:'/'}">首页</el-breadcrumb-item>
          <el-breadcrumb-item>农业百科</el-breadcrumb-item>
        </el-breadcrumb>

        <div class="tap-conts">
          <el-tabs v-model="activeName3" @tab-click="handleClick3">
            <template v-for=" (item,index) in nameList">
              <el-tab-pane
                :label="item.names"
                :key="index"
                :name="second != ''?item.idName:item.idName"
                :data="item.category"
              >
                <ul class="clearf" v-if="List">
                  <li
                    class="problem-items"
                    v-for="(setitem,index) in List"
                    :key="index"
                    @click="problemClick(setitem)"
                  >
                    <a>{{setitem.title}}</a>
                    <div class="clearf cats">
                      <img
                        v-if="setitem.coverUrl"
                        style="width:200px;height:133px;float: left;margin-top:10px;"
                        :src="$img + setitem.coverUrl"
                        alt
                      />
                      <p v-if="setitem.coverUrl" class="summary"  style="width:74%;float: right;">
                        <span class="font-style">{{setitem.summary}}</span>
                      </p>
                      <p v-if="!setitem.coverUrl" class="summary" style="width:100%;">
                        <span class="font-style">{{setitem.summary}}</span>
                      </p>
                      <p class="text-end">
                      <span class="right-fiftys">{{setitem.publishDate}}</span>
                      <span class="right-ten">发布人：{{setitem.publishByName}}</span>
                    </p>
                    </div>

                    
                  </li>
                </ul>
                <div class="contentList" v-if="List.length < 1">暂无内容哦~</div>
              </el-tab-pane>
            </template>
          </el-tabs>
          <div class="pagings" v-if="List.length > 0">
            <span class="demonstration"></span>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage1"
              :page-size="20"
              layout="total, prev, pager, next,jumper"
              :total="respData.totalElements"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div class="right-box">
        <recommendation />
      </div>
    </div>
  </div>
</template>

<script>
import recommendation from "../components/recommendation";
export default {
  data() {
    return {
      recommendation: "",
      activeName3: "first",
      pageSize: "20",
      pageNum: "1",
      category: "e6d895f9d2aa11e9bddcda211f4fee1e",
      List: [],
      currentPage1: 0,
      respData: "",
      second: "",
      idName: "",
      nameList: [
        {
          names: "农业气象",
          category: "e6d895f9d2aa11e9bddcda211f4fee1e"
        },
        {
          names: "农业政策",
          category: "f96d6cb1d2aa11e9bddcda211f4fee1e"
        },
        {
          names: "市场行情",
          category: "08f0b894d2ab11e9bddcda211f4fee1e"
        },
        {
          names: "实用技术",
          category: "19b08a4ad2ab11e9bddcda211f4fee1e"
        },
        {
          names: "防灾减灾",
          category: "23da9d56d2ab11e9bddcda211f4fee1e"
        },
        {
          names: "病虫治理",
          category: "2f1a09c4d2ab11e9bddcda211f4fee1e"
        }
      ],
      abList: []
    };
  },
  components: {
    recommendation
  },
  mounted() {
    // 百科列表接口
    
    if (this.$route.query.second) {
      let second = this.$route.query.second || "";
      this.second = second;
    }
    this.wikiPage();
    let that = this;
    // console.log(this.$route.query.second);
    this.abList = this.nameList.map(function(obj, index) {
      console.log(that.second);
      if (!that.second && index == 0) {
        obj.idName = "first";
      } else if (that.second && index == 1) {
        obj.idName = "first";
      }
      return obj;

      console.log(obj);
    });
  },
  methods: {
    // 百科列表接口
    wikiPage(obj) {
      let pageSize = this.pageSize;
      let pageNum = this.pageNum;

      if (this.second) {
        this.category = this.nameList[2].category;
      }

      const data = {
        category: this.category,
        pageSize: pageSize,
        pageNum: pageNum
      };
      this.$api.wikiApi
        .wikiList(data)
        .then(res => {
          console.log("百科列表=>", res);
          this.List = res.data.respData.content || "";

          this.respData = res.data.respData;
        })
        .catch(err => {
          console.log("err=>", err);
        });
    },
    problemClick(setitem) {
      let tid = setitem.tid;
      this.$router.push({
        path: "/WikiDetails",
        query: {
          tid: tid
        }
      });
    },
    // elm-tab组件点击
    handleClick3(tab, event) {
      console.log(tab.$attrs.data);
      this.category = tab.$attrs.data;
      this.wikiPage();
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.wikiPage();
      this.pageNum = "1";
    }
  }
};
</script>

<style lang="less">
.contentList {
  padding: 10% 40%;
}

.tap-conts {
  float: left;
  margin-top: 15px;
  // background-color: #fff;
  width: calc(100% - 0px);
  .problem-items {
    float: left;
    width: 100%;
    margin-bottom: 20px;
    padding: 15px;
    background: #fff;
    position: relative;
    cursor: pointer;
    a {
      display: block;
      width: 100%;
      font-size: 18px;
      color: #222;
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &:hover {
        color: #149508;
      }
    }

    p {
      font-size: 14px;
      padding: 5px 0;
      .font-style {
        color: #666;
        font-size: 16px;
        line-height: 25px;
        // height: 80px;
        letter-spacing: 1px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }
      .right-fiftys {
        display: inline-block;
        padding-right: 50px;
        color: #999;
        margin-top:5px;
      }
      .right-ten {
        padding-right: 10px;
        color: #999;
      }
    }
  }
  .summary{
    position: relative;
    margin-bottom: 20px;
  }
  .el-tabs {
    width: 100%;
    margin-bottom: 10px;
  }
  .el-tabs__nav-wrap::after {
    height: 0;
  }
  .el-tabs__header {
    background: #fff;
    padding: 0 15px;
  }
  .el-tabs__item {
    font-size: 18px;
    padding: 0px 30px;
  }
}

// element样式修改
// .el-input__inner{
//   width: 40px;
//   border: none;
// }

.el-tabs__item.is-active {
  color: #149508;
}
.el-tabs__item:hover {
  color: #149508;
  cursor: pointer;
}
.el-tabs__active-bar {
  background-color: #149508;
}
.text-end {
  text-align: end;
  position: absolute;
  bottom:15px;
  right: 0
}
// elemui组件
.el-breadcrumb {
  background-color: #fff;
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  padding: 0 15px;
}
.el-breadcrumb__inner.is-link {
  color: #333;
  font-weight: normal;
}
.el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: #149508;
}
.el-breadcrumb__separator {
  color: #333;
}
.left-box {
  float: left;
  width: 848px;
  margin-top: 20px;
}
.right-box {
  float: right;
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/encyclopedias.vue